@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
.card-container {
  top: 12px;
  height: 47px;
  max-height: 47px;
  position: absolute;
  border: 0.5px solid;
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
  animation: fadeIn 0.2s ease-out;
}
.card-container.exiting {
  animation: fadeOut 0.2s ease-in forwards;
  pointer-events: none;
}
.card-container-completed {
  background-color: var(--color-feedback-positive-300);
  border-color: var(--color-feedback-positive-300);
}
.card-container-not-started {
  background-color: var(--color-neutral-400);
  border-color: var(--color-neutral-400);
}
.card-container-not-executed {
  background-color: var(--color-feedback-danger-300);
  border-color: var(--color-feedback-danger-300);
}
.card-container-error {
  background-color: #FFC629;
  border-color: #FFC629;
}
.card-container-awaiting-justification {
  background-color: var(--feedback-danger-400, var(--color-feedback-danger-400, #AE1E1E));
  border-color: var(--feedback-danger-400, var(--color-feedback-danger-400, #AE1E1E));
}
.card-container-completed-late {
  background-color: var(--color-feedback-positive-300);
  border-color: var(--color-feedback-positive-300);
}
.card-container-in-progress, .card-container-awaiting-end {
  background-color: #559CF8;
  border-color: #559CF8;
}
.card-content {
  margin-left: 4px;
  border-radius: 8px;
  height: 47px;
  max-height: 47px;
  width: 100%;
  background: #EDEDED;
  font-size: 10px;
  font-weight: 500;
}
.card-content-description {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.card-content-critico {
  position: absolute;
  top: 0;
  right: 8px;
}
.card-content-padding {
  padding: 10px 6px 0px;
}
.card-content-completed, .card-content-not-started {
  color: var(--color-neutral-400);
}
.card-content-not-executed {
  background-color: var(--color-feedback-danger-100);
  color: var(--color-neutral-600);
}
.card-content-error, .card-content-in-progress, .card-content-awaiting-end {
  background-color: #FFFFFF;
  color: var(--color-neutral-600);
}
.card-content-awaiting-justification {
  background-color: #FFFFFF;
  color: var(--feedback-danger-300, #C92323);
}
.card-content-awaiting-justification svg,
.card-content-awaiting-justification path {
  color: var(--feedback-danger-300, #C92323);
  fill: var(--feedback-danger-300, #C92323);
}
.card-content-completed-late {
  background-color: #FFFFFF;
  color: var(--color-feedback-positive-600);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */